import React from 'react';
import { RelationalOperatorKey } from '../../../utils/apollo/graphqlSchema';
import { SingleSelectMenu } from '../../Dropdown';

const options = [
  {
    value: RelationalOperatorKey.Equal,
    text: 'Equals',
  },
  {
    value: RelationalOperatorKey.Notequal,
    text: 'Does not equal',
  },
  {
    value: RelationalOperatorKey.StartsWith,
    text: 'Begins with',
  },
  {
    value: RelationalOperatorKey.NotStartsWith,
    text: 'Does not begin with',
  },
  {
    value: RelationalOperatorKey.EndsWith,
    text: 'Ends with',
  },
  {
    value: RelationalOperatorKey.NotEndsWith,
    text: 'Does not end with',
  },
  {
    value: RelationalOperatorKey.Contains,
    text: 'Contains',
  },
  {
    value: RelationalOperatorKey.NotContains,
    text: 'Does not contain',
  },
];

const ColumnFilterConditionSelect = ({
  filterCondition,
  onChange,
}: {
  filterCondition?: RelationalOperatorKey;
  onChange: (condition: RelationalOperatorKey) => void;
}) => {
  const handleChange = (value: string) => {
    onChange(value as RelationalOperatorKey);
  };

  return (
    <SingleSelectMenu
      placeholder="Select a condition"
      options={options}
      value={filterCondition ?? null}
      onChange={handleChange}
      customWidth="216px"
    />
  );
};

export default ColumnFilterConditionSelect;
